module.exports = __webpack_public_path__ + "static/media/parker-ridge.b362e2f6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/parker-ridge.png
 ** module id = 188
 ** module chunks = 0
 **/